import React from "react";
import Client1 from "../Assets/Artboard 7@300x (1).png";
import Client2 from "../Assets/Client1.jpg";
import {
  FaCar,
  FaIndustry,
  FaHeartbeat,
  FaMicrochip,
  FaBuilding,
  FaBriefcase,
  FaHandshake,
  FaBullseye,
  FaCheckCircle,
  FaLink,
  FaLayerGroup,
  FaLeaf,
} from "react-icons/fa";

import bajajLogo from "../Assets/Asset 4.png";
import Hero from "../Assets/Asset 2.png";
import Mahindra from "../Assets/Asset 1.png";
import Atul from "../Assets/Atul.png";
import Wockhardt from "../Assets/wockhardtpng.png";
import Haier from "../Assets/Haier.png";
import Legrand from "../Assets/Asset 3.png";
import Schneider from "../Assets/Schneider.png";
import Perkins from "../Assets/Asset 5.png";
import JSW from "../Assets/JSW-removebg-preview.png";
import Lumax from "../Assets/Lumax.png";
import NRB from "../Assets/NRB-logo.png";



function Clients() {
  // const clients = [
  //   "Bajaj",
  //   "Hero",
  //   "Mahindra",
  //   "Atul",
  //   "Wockhardt",
  //   "Haier",
  //   "Legrand",
  //   "Schneider Electric",
  //   "Perkins",
  //   "JSW",
  //   "Lumax",
  //   "NRB",
  // ];

  const clients = [
    { name: "Bajaj", logo: bajajLogo },
    { name: "Hero", logo: Hero },
    { name: "Mahindra", logo: Mahindra },
    { name: "Atul", logo: Atul },
    { name: "Wockhardt", logo: Wockhardt },
    { name: "Haier", logo: Haier },
    { name: "Legrand", logo: Legrand },
    { name: "Schneider Electric", logo: Schneider },
    { name: "Perkins", logo: Perkins },
    { name: "JSW", logo: JSW },
    { name: "Lumax", logo: Lumax },
    { name: "NRB", logo: NRB },
  ];

  const industries = [
    "Automotive",
    "Manufacturing",
    "Healthcare",
    "Electrical & Electronics",
    "Industrial Infrastructure",
    "Commercial Applications",
  ];

  const strengths = [
    "Long-term engineering partnerships",
    "Industry-focused solution delivery",
    "Reliable project execution",
    "Strong technology alignment",
    "Support across multiple application domains",
    "Commitment to efficiency and sustainability",
  ];
  const industryIcons = {
  Automotive: <FaCar size={28} />,
  Manufacturing: <FaIndustry size={28} />,
  Healthcare: <FaHeartbeat size={28} />,
  "Electrical & Electronics": <FaMicrochip size={28} />,
  "Industrial Infrastructure": <FaBuilding size={28} />,
  "Commercial Applications": <FaBriefcase size={28} />,
};

const strengthIcons = {
  "Long-term engineering partnerships": <FaHandshake size={28} />,
  "Industry-focused solution delivery": <FaBullseye size={28} />,
  "Reliable project execution": <FaCheckCircle size={28} />,
  "Strong technology alignment": <FaLink size={28} />,
  "Support across multiple application domains": <FaLayerGroup size={28} />,
  "Commitment to efficiency and sustainability": <FaLeaf size={28} />,
};

  return (
    <div style={{ backgroundColor: "#f7fbff", overflowX: "hidden" }}>
     <section
  style={{
    background:
      "linear-gradient(135deg, #edf7ff 0%, #d8ecfb 45%, #f7fbff 100%)",
    padding: "90px 0 70px 0",
    position: "relative",
    overflow: "hidden",
  }}
>
  <div
    style={{
      position: "absolute",
      top: "30px",
      left: "-70px",
      width: "220px",
      height: "220px",
      borderRadius: "50%",
      background: "rgba(29,169,232,0.10)",
      filter: "blur(10px)",
      animation: "floatY 5s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    style={{
      position: "absolute",
      bottom: "20px",
      right: "-60px",
      width: "240px",
      height: "240px",
      borderRadius: "50%",
      background: "rgba(11,92,173,0.10)",
      filter: "blur(10px)",
      animation: "floatY 6s ease-in-out infinite",
      zIndex: 0,
      pointerEvents: "none",
    }}
  ></div>

  <div
    className="container"
    style={{
      position: "relative",
      zIndex: 2,
    }}
  >
    <div className="row align-items-center gy-5">
      <div className="col-lg-6">
        <div
          style={{
            display: "inline-block",
            backgroundColor: "#e6f4ff",
            color: "#0B5CAD",
            padding: "10px 18px",
            borderRadius: "30px",
            fontWeight: 700,
            fontSize: "14px",
            marginBottom: "18px",
            animation: "fadeUp 1s ease",
          }}
        >
          OUR CLIENTS
        </div>

        <h1
          style={{
            color: "#0B5CAD",
            fontWeight: 800,
            fontSize: "clamp(2.2rem, 5vw, 3.8rem)",
            lineHeight: "1.15",
            marginBottom: "18px",
            animation: "fadeUp 1.1s ease",
          }}
        >
          Trusted By
          <br />
          Leading Industries
        </h1>

        <p
          style={{
            color: "#4a5568",
            fontSize: "17px",
            lineHeight: "1.9",
            marginBottom: "24px",
            animation: "fadeUp 1.2s ease",
          }}
        >
          Electromates serves a diverse customer base across multiple
          sectors by delivering automation, energy and sustainability
          solutions with strong engineering execution and practical
          deployment support.
        </p>

        <div className="row g-3">
          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                10+
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Featured Clients
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Multi
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Industry Presence
              </p>
            </div>
          </div>

          <div className="col-4">
            <div
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "18px",
                padding: "16px 10px",
                boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
                textAlign: "center",
                height: "100%",
              }}
            >
              <h3
                style={{
                  color: "#1DA9E8",
                  fontWeight: 800,
                  marginBottom: "6px",
                  fontSize: "clamp(1rem, 2vw, 1.6rem)",
                }}
              >
                Trusted
              </h3>
              <p
                style={{
                  margin: 0,
                  color: "#2d3748",
                  fontWeight: 600,
                  fontSize: "clamp(11px, 1.5vw, 14px)",
                  lineHeight: "1.4",
                }}
              >
                Solution Delivery
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="col-lg-6">
        <div
          style={{
            width: "100%",
            position: "relative",
            zIndex: 1,
            borderRadius: "28px",
            overflow: "hidden",
            animation: "zoomInSoft 1.2s ease",
            aspectRatio: "16 / 10",
          }}
        >
          <img
            src={Client1}
            alt="Clients and Partners"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  </div>
</section>

    <section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
    overflow: "hidden",
  }}
>
  <div className="container py-4">
    <div className="text-center mb-5">
      <h2
        style={{
          color: "#0B5CAD",
          fontWeight: 800,
          marginBottom: "12px",
        }}
      >
        Client Network
      </h2>
      <p
        style={{
          maxWidth: "820px",
          margin: "0 auto",
          color: "#5b6777",
          lineHeight: "1.8",
        }}
      >
        Electromates has supported customers across sectors with automation,
        energy-efficiency and infrastructure-focused engineering solutions.
        Client spread across well-known organizations.
      </p>
    </div>

    <div
      style={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
      }}
      onMouseEnter={(e) => {
        const track = e.currentTarget.querySelector(".client-network-track");
        if (track) track.style.animationPlayState = "paused";
      }}
      onMouseLeave={(e) => {
        const track = e.currentTarget.querySelector(".client-network-track");
        if (track) track.style.animationPlayState = "running";
      }}
    >
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          bottom: 0,
          width: "90px",
          zIndex: 2,
          pointerEvents: "none",
          background:
            "linear-gradient(90deg, #eef7fd 0%, rgba(238,247,253,0.85) 35%, rgba(238,247,253,0) 100%)",
        }}
      />

      <div
        style={{
          position: "absolute",
          right: 0,
          top: 0,
          bottom: 0,
          width: "90px",
          zIndex: 2,
          pointerEvents: "none",
          background:
            "linear-gradient(270deg, #eef7fd 0%, rgba(238,247,253,0.85) 35%, rgba(238,247,253,0) 100%)",
        }}
      />

      <div
        className="client-network-track"
        style={{
          display: "flex",
          width: "max-content",
          gap: "20px",
          animation: "scrollClientNetwork 28s linear infinite",
        }}
      >
        {[...clients, ...clients].map((client, index) => (
          <div
            key={index}
            style={{
              minWidth: "180px",
              maxWidth: "180px",
              backgroundColor: "#ffffff",
              borderRadius: "20px",
              padding: "20px 16px",
              textAlign: "center",
              boxShadow: "0 10px 30px rgba(11,92,173,0.08)",
              border: "1px solid rgba(11,92,173,0.08)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)";
              e.currentTarget.style.boxShadow =
                "0 16px 34px rgba(11,92,173,0.14)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow =
                "0 10px 30px rgba(11,92,173,0.08)";
            }}
          >
            <div
              style={{
                width: "100px",
                height: "64px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "12px",
              }}
            >
              <img
                src={client.logo}
                alt={client.name}
                style={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>

            <div
              style={{
                color: "#0B5CAD",
                fontWeight: 700,
                fontSize: "15px",
                lineHeight: "1.4",
                minHeight: "40px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {client.name}
            </div>
          </div>
        ))}
      </div>
    </div>

    <style>
      {`
        @keyframes scrollClientNetwork {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}
    </style>
  </div>
</section>

     <section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #ffffff 0%, #eef7fd 100%)",
  }}
>
  <div className="container py-4">
    <div className="row align-items-center gy-4">
      <div className="col-lg-6">
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "24px",
            padding: "34px",
            boxShadow: "0 12px 35px rgba(0,0,0,0.05)",
            borderLeft: "6px solid #1DA9E8",
          }}
        >
          <h2
            style={{
              color: "#0B5CAD",
              fontWeight: 800,
              marginBottom: "18px",
            }}
          >
            Why Clients Work With Electromates
          </h2>

          <p style={{ color: "#4a5568", lineHeight: "1.95" }}>
            Electromates combines engineering fundamentals,
            solution-centric thinking and disciplined execution. This
            helps customers confidently adopt automation, improve
            efficiency and address sustainability goals through practical,
            deployment-ready solutions.
          </p>

          <p
            style={{
              color: "#4a5568",
              lineHeight: "1.95",
              marginBottom: 0,
            }}
          >
            The company’s relationships reflect trust built through
            reliable delivery, technical depth and the ability to support
            multiple application areas across different industries.
          </p>
        </div>
      </div>

      <div className="col-lg-6">
        <div
          style={{
            width: "100%",
            borderRadius: "24px",
            overflow: "hidden",
            position: "relative",
            aspectRatio: "16 / 10",
          }}
        >
          <img
            src={Client2}
            alt="Project Customer"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
    </div>
  </div>
</section>

    <section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #f7fbff 0%, #ffffff 100%)",
  }}
>
  <div className="container py-4">
    <h2
      style={{
        color: "#0B5CAD",
        fontWeight: 800,
        marginBottom: "24px",
        textAlign: "center",
        fontSize: "clamp(2rem, 4vw, 2.6rem)",
      }}
    >
      Industries We Serve
    </h2>

    <div className="row g-4">
      {industries.map((item, index) => (
        <div className="col-sm-6 col-lg-4" key={index}>
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "20px",
              padding: "26px 22px",
              boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
              border: "1px solid rgba(11,92,173,0.08)",
              height: "100%",
              textAlign: "center",
              transition: "all 0.3s ease",
            }}
          >
            <div
              style={{
                width: "68px",
                height: "68px",
                margin: "0 auto 16px",
                borderRadius: "18px",
                background: "linear-gradient(135deg, #e8f4ff 0%, #d8ecfb 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#0B5CAD",
                boxShadow: "0 8px 18px rgba(11,92,173,0.08)",
              }}
            >
              {industryIcons[item]}
            </div>

            <div
              style={{
                color: "#0B5CAD",
                fontWeight: 700,
                fontSize: "20px",
                lineHeight: "1.4",
              }}
            >
              {item}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

<section
  className="py-5"
  style={{
    background: "linear-gradient(180deg, #ffffff 0%, #f7fbff 100%)",
  }}
>
  <div className="container py-4">
    <h2
      style={{
        color: "#0B5CAD",
        fontWeight: 800,
        marginBottom: "24px",
        textAlign: "center",
        fontSize: "clamp(2rem, 4vw, 2.6rem)",
      }}
    >
      Partnership Strengths
    </h2>

    <div className="row g-4">
      {strengths.map((item, index) => (
        <div className="col-sm-6 col-lg-4" key={index}>
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "20px",
              padding: "26px 22px",
              boxShadow: "0 12px 28px rgba(11,92,173,0.08)",
              border: "1px solid rgba(11,92,173,0.08)",
              height: "100%",
              textAlign: "center",
              transition: "all 0.3s ease",
            }}
          >
            <div
              style={{
                width: "68px",
                height: "68px",
                margin: "0 auto 16px",
                borderRadius: "18px",
                background: "linear-gradient(135deg, #e8f4ff 0%, #d8ecfb 100%)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#0B5CAD",
                boxShadow: "0 8px 18px rgba(11,92,173,0.08)",
              }}
            >
              {strengthIcons[item]}
            </div>

            <div
              style={{
                color: "#0B5CAD",
                fontWeight: 700,
                fontSize: "19px",
                lineHeight: "1.5",
              }}
            >
              {item}
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</section>

      <section className="py-5">
        <div className="container py-4">
          <div
            style={{
              background: "linear-gradient(135deg, #0B5CAD 0%, #1DA9E8 100%)",
              borderRadius: "28px",
              padding: "50px 30px",
              textAlign: "center",
              color: "#ffffff",
              boxShadow: "0 16px 40px rgba(11,92,173,0.20)",
            }}
          >
            <h2 style={{ fontWeight: 800, marginBottom: "14px" }}>
              Looking For a Trusted Engineering Partner?
            </h2>
            <p
              style={{
                maxWidth: "760px",
                margin: "0 auto 24px",
                lineHeight: "1.85",
                color: "rgba(255,255,255,0.92)",
              }}
            >
              Electromates works with organizations across industries to
              deliver dependable automation, energy and sustainability
              solutions backed by practical engineering support.
            </p>

            <a
              href="/contact"
              className="btn"
              style={{
                backgroundColor: "#ffffff",
                color: "#0B5CAD",
                padding: "12px 28px",
                borderRadius: "30px",
                fontWeight: 700,
                border: "none",
              }}
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Clients;